/**
 * ImageWithCaption: an image that carries its own dimensions, title and
 * description, so the photograph and its words balance as one unit inside
 * the page composition (e.g. 764 × 432 sitting lower-right in the hero).
 *
 *   image   { src, w, h, alt }   from data/images.js
 *   title   short caption title
 *   text    one or two sentences of description
 *   showDims  render the "764 × 432" label in the lower-right corner
 *   parallax  subtle scroll drift of the photo inside its frame
 *   align   "right" | "left" – which edge the caption text hangs from
 */
import { useParallax } from "../lib/hooks";

export default function ImageWithCaption({ image, title, text, index, showDims = true, parallax = true, align = "left", className = "", rv = true, style }) {
  const ref = useParallax(parallax ? 26 : 0);
  return (
    <figure className={`iwc iwc--${align} ${className}`.trim()} style={style} {...(rv ? { "data-rv": "" } : {})}>
      <div className="iwc-frame" ref={ref} style={{ aspectRatio: `${image.w} / ${image.h}` }}>
        <img className="iwc-img" src={image.src} alt={image.alt} width={image.w} height={image.h} loading="lazy" decoding="async" />
      </div>
      <figcaption className="iwc-cap">
        <div className="iwc-cap-text">
          {(index || title) && (
            <span className="iwc-title">
              {index && <span className="iwc-index">{index}</span>}
              {title}
            </span>
          )}
          {text && <span className="iwc-desc">{text}</span>}
        </div>
        {showDims && <span className="iwc-dims">{image.w} × {image.h}</span>}
      </figcaption>
    </figure>
  );
}
